<template>
    <div class="tile-content tile-content-secondary">
        <div class="grid-content">
            <div class="grid-item grid-item-full">
                <p>Show various choices to display based on the user's detected language.</p>
            </div>
        </div>
        <div class="divider divider-tile-content"></div>
        <choices-editor
            :choices="action.choices"
            :validate="$v.action.choices"
            @input="updateChoices"/>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import ChoicesEditor from '@/modules/rules-engine/actions/display-other-choices/components/choices-editor';
    import BaseAction from '../base-action';

    export default {
        name: 'display-other-choices',
        extends: BaseAction,
        components: {
            ChoicesEditor,
        },
        data() {
            return {
                isSelecting: false,
            };
        },
        validations: {
            action: {
                choices: {
                    $each: {
                        content: {required},
                    },
                },
            },
        },
        methods: {
            updateChoices(choices) {
                this.$emit('input', this.action.cloneSelf({choices}));
            },
            getValidationAggregate() {
                return {
                    name: 'display-other-choices',
                    rules: [
                        {
                            name: 'You must provide content for each language choice.',
                            delegate: () => {
                                this.$v.$touch();
                                return this.$v.action.choices.$error;
                            },
                        },
                    ],
                };
            },
        },
    };
</script>
